import { AnimatePresence, motion } from "framer-motion";

import { Span } from "@virtual-brain-lib/frontend-design-system/ui";
import { cn } from "@virtual-brain-lib/frontend-design-system/utils";

interface ToolCardStatusTextProps {
	readonly statusText: string;
	readonly className?: string;
}

export function ToolCardStatusText({ statusText, className }: ToolCardStatusTextProps) {
	return (
		<AnimatePresence mode="wait" initial={false}>
			<motion.div
				key={statusText}
				animate={{ opacity: 1, y: 0 }}
				exit={{ opacity: 0, y: -2 }}
				initial={{ opacity: 0, y: 2 }}
				transition={{ duration: 0.2, ease: "easeOut" }}
			>
				<Span className={cn("italic", className)} color="defaultLight" variant="body-xs">
					{statusText}
				</Span>
			</motion.div>
		</AnimatePresence>
	);
}
